import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginAction } from '../actions';

function Login()
{
    // local storage
    const storage = require('../tokenStorage.js');
    // maybe unecessary
    var tok = storage.retrieveToken();

    var loginName;
    var loginPassword;

    // redux
    const dispatch = useDispatch();

    const [message,setMessage] = useState('');

    const handleLogin = async event => {
       
        event.preventDefault();

        if(loginName.value.length <= 0 || loginPassword.value.length <= 0){
            return
        }

        var obj = {
            username: loginName.value, // username or user
            password: loginPassword.value
        };
        var js = JSON.stringify(obj);
        console.log(js)
        try {    

            const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/auth/login`,
                {method:'POST', body: js,headers: {'Content-Type': 'application/json'}});

            var res = JSON.parse(await response.text());

            console.log(res);

            if( res.id <= 0 )
                setMessage('User/Password combination incorrect');
            
            else
            {

                var user = {
                    firstName: res.first_name,
                    lastName: res.last_name,
                    id: res.user_id,
                    groupId: res.group_id,
                    member_id: res.member_id,
                    class_id: res.class_id
                }
                localStorage.setItem('user', JSON.stringify(user));
                
                storage.storeToken(res);

                // user has just logged in
                dispatch(loginAction());

                // local storage
                storage.storeToken('user', JSON.stringify(user));
                
                //redux store
                //dispatch(store(res));
                
                setMessage('');
                
                if (res.type == 'admin')
                    window.location.href = '/R3g1strati0nPag3Acc3ss';

            }
        }
        catch(e)
        {
            alert(e.toString());
            return;
        }    
    }

    return(
        <div className='loginSection'>
            <p>SENIOR DESIGN PORTAL</p>
            <form onSubmit = {handleLogin}>
                <input type="text" className="loginField" placeholder="Username" ref ={(c) => loginName = c } required/><br/>
                <input type="password" className="loginField" placeholder="Password" ref ={(c) => loginPassword = c} required/><br/>
                <input type="submit" className="UCFbutton" onClick={handleLogin}/><br/>
            </form>
                <a href="https://www.cs.ucf.edu/~cssd" id ='passwordReset'>SSO</a>
            <span id="loginResult"></span>
        </div>
    );
}
export default Login;